/**
 * Varianten-Selektor (PDP): "+N"-Kachel bei vielen Farben und Ruecksprung bei Groessenwechsel.
 * Wird per defer geladen, einmal je Seite. Ohne JS bleiben alle Kacheln sichtbar.
 */
(function () {
  if (window.__mkVariantSelectorInit) return;
  window.__mkVariantSelectorInit = true;

  var KEY = 'mk_vs_scroll';
  var MAX_AGE = 15000;
  var mq = window.matchMedia('(max-width: 600px)');

  /* ---------- "+N": alle Farbkacheln aufklappen ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.custom-variant-selector .mk-more');
    if (!btn) return;
    var wrap = btn.closest('.option-values-wrapper');
    if (!wrap) return;
    var firstHidden = wrap.querySelector('.mk-hide');
    wrap.classList.add('mk-open');
    btn.setAttribute('aria-expanded', 'true');
    if (firstHidden && firstHidden.focus) {
      try { firstHidden.focus({ preventScroll: true }); } catch (err) { /* ignore */ }
    }
  });

  /* ---------- Ruecksprung bei Groessenwechsel (nur <= 600 px) ---------- */
  function store(data) {
    try { sessionStorage.setItem(KEY, JSON.stringify(data)); } catch (err) { /* ignore */ }
  }
  function read() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (err) { return null; }
  }
  function clear() {
    try { sessionStorage.removeItem(KEY); } catch (err) { /* ignore */ }
  }

  document.addEventListener('click', function (e) {
    if (!mq.matches || e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest && e.target.closest('.custom-variant-selector .size-selector a[href]');
    if (!link) return;
    var sel = link.closest('.custom-variant-selector');
    if (!sel) return;
    var path;
    try { path = new URL(link.href, location.href).pathname; } catch (err) { return; }
    store({ p: path, t: Math.round(sel.getBoundingClientRect().top), ts: Date.now() });
  }, true);

  var userScrolled = false;
  ['wheel', 'touchmove', 'keydown', 'mousedown'].forEach(function (ev) {
    window.addEventListener(ev, function () { userScrolled = true; }, { passive: true, once: true });
  });

  var pending = null; // gemerkte Daten, solange noch nachkorrigiert werden darf

  function scrollToSaved(d) {
    var sel = document.getElementById('variant-selector');
    if (!sel) return;
    var target = sel.getBoundingClientRect().top + window.pageYOffset - d.t;
    if (target < 0) target = 0;
    if (Math.abs(window.pageYOffset - target) > 1) window.scrollTo(0, target);
  }

  function restore() {
    var d = read();
    if (!d) return;
    clear();
    if (!mq.matches) return;
    if (d.p !== location.pathname) return;
    if (!d.ts || Date.now() - d.ts > MAX_AGE) return;
    // Zurueck/Vor und Neuladen: kein Sprung
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav && nav.type !== 'navigate' && nav.type !== 'prerender') return;
    } catch (err) { /* ignore */ }
    scrollToSaved(d);
    pending = d;
    // einmal nachkorrigieren, falls sich das Layout bis zum load verschoben hat
    var correct = function () {
      if (pending && !userScrolled) scrollToSaved(pending);
      pending = null;
    };
    if (document.readyState === 'complete') {
      requestAnimationFrame(correct);
    } else {
      window.addEventListener('load', function () { requestAnimationFrame(correct); }, { once: true });
    }
  }

  function start() {
    if (document.prerendering) {
      // Prerender: erst nach der Aktivierung, sonst wuerde der Schluessel zu frueh gelesen
      document.addEventListener('prerenderingchange', restore, { once: true });
    } else {
      restore();
    }
  }

  // bfcache: Seite wird wiederhergestellt, kein Sprung, Schluessel verwerfen
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { pending = null; clear(); }
  });

  start();
})();
